import { COMMUNITY_SLACK_URL } from "@/utils/community-support";
import { usePylonEnabled } from "@/utils/hooks/use-pylon-enabled";
import { DropdownMenu, DropdownMenuItem } from "@/components/interactive/DropdownMenu";
import { IconButton } from "@/components/interactive/IconButton";
import { useRouteInfo } from "@/utils/hooks/url/use-route-info";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { usePagerDutyEscalation } from "@/utils/hooks/use-pagerduty-escalation";
import { useFlagsV2 } from "@/utils/hooks/use-flags-grpc";
import { useNextEnvVars } from "@/components/context-providers/NextEnvVarsWrapper";

export function SupportDropdown() {
  const { projectId, environmentId } = useRouteInfo();
  const session = useSession();
  const router = useRouter();
  const user = session.data?.user;

  const { escalateIssue, isCreatingIncident } = usePagerDutyEscalation();
  const isEnterpriseSupport = useFlagsV2().enabled("enterprise_support_enabled");
  const { CHALK_DEPLOYMENT_MODEL } = useNextEnvVars();
  const isSelfHosted = CHALK_DEPLOYMENT_MODEL === "CUSTOMER_CLOUD";
  const pylonEnabled = usePylonEnabled();

  const handleStartChat = () => {
    window.Pylon("showNewMessage");
  };

  const handleSubmitRequest = () => {
    if (typeof window !== "undefined" && window.Pylon) {
      window.Pylon("showTicketForm", "submit-a-request");
    } else {
      console.warn("Pylon widget not available");
    }
  };

  const handlePagerDuty = () => {
    escalateIssue({
      userEmail: user?.email || "Unknown User",
      projectId,
      environmentId,
      currentUrl: `${window.location.origin}${router.asPath}`,
    });
  };

  return (
    <DropdownMenu
      floatOptions={{ placement: "bottom-end" }}
      renderButton={(ref) => (
        <IconButton
          ref={ref}
          iconName="question"
          iconClassName="h-5 w-5"
          size="sm"
          color="secondary"
        />
      )}
    >
      <DropdownMenuItem
        href={COMMUNITY_SLACK_URL}
        target="_blank"
        rel="noopener noreferrer"
        icon="messageSquare"
      >
        Community Slack
      </DropdownMenuItem>
      {pylonEnabled && (
        <>
          <DropdownMenuItem
            href="https://portal.usepylon.com/chalk"
            target="_blank"
            rel="noopener noreferrer"
            icon={"arrowExternal"}
          >
            Customer Portal
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleStartChat} icon={"messageCircle"}>
            Start Chat
          </DropdownMenuItem>
          <DropdownMenuItem onClick={handleSubmitRequest} icon={"ticket"}>
            Submit Request
          </DropdownMenuItem>
        </>
      )}
      {isEnterpriseSupport && !isSelfHosted && (
        <DropdownMenuItem
          onClick={handlePagerDuty}
          disabled={isCreatingIncident}
          icon={"phoneArrowUpRight"}
        >
          {isCreatingIncident ? "Creating Incident..." : "Escalate Issue"}
        </DropdownMenuItem>
      )}
    </DropdownMenu>
  );
}
